
import axios from "@/services/axios";
import Galleria from "primevue/galleria";
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  inject,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import ResearchEquipmentDetailDto from "../research-equipment-detail-dto";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import ResearchEquipmentRepositoryAPI from "@/modules/research-equipment/research-equipment-repository-api";
import { useI18n } from "vue-i18n";
import { location } from "@/utils/default-data";
import {
  Language,
  getCategoryLanguageName,
  selectedLocale,
} from "@/locales/i18n";
import DateFormatingService from "@/modules/dateFormatingService";

interface ResponsibleUserContactView {
  name: string;
  email: string;
  mobile: string;
}

export default defineComponent({
  components: {
    Galleria,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    compare: {
      type: Boolean,
      default: true,
    },
    class: {
      type: String,
      default: "productFull",
    },
  },
  setup(props) {
    const { t } = useI18n();
    const route = useRoute();
    const localProperty = getCategoryLanguageName();
    let id = route.params.id as string;
    if (props.id != "") {
      id = props.id as string;
    }

    const keycloak = inject("keycloak") as Keycloak.KeycloakInstance;
    const { getAuth } = UserRepositoryAPI();
    const { setResearchEquipment } = ResearchEquipmentRepositoryAPI();
    const { formatDate } = DateFormatingService();
    const router = useRouter();

    const state = reactive({
      localProperty: localProperty,
      responsibleUserContact: {} as ResponsibleUserContactView,
      item: {
        researchEquipmentPrice: [] as Array<any>,
      } as ResearchEquipmentDetailDto,
      images: [] as Array<string>,
      id: "",
      showGallery: false,
      productImage: "",
      showLoginDialog: false,
      showRegistrationDialog: false,
    });
    const getDetailData = (id: string) => {
      axios.get(`api/v1/ResearchEquipment/${id}/detail`).then((response) => {
        state.item = response.data as ResearchEquipmentDetailDto;
        state.id = response.data.id;
        state.responsibleUserContact = mapResponsibleUserContactView(
          response.data.contactUsers
        );
      });
    };

    async function getEquipmentImages(id: string) {
      axios.get(`api/v1/ResearchEquipment/${id}/images`).then((response) => {
        state.images = response.data;
        if (response.data.length > 0) {
          state.productImage = response.data[0].url;
        }
      });
    }

    const onBookEquipmentClick = (item: any): void => {
      const isAuthenticated = getAuth.value.isAuthenticated as boolean;
      if (!isAuthenticated) {
        state.showLoginDialog = true;
        return;
      }
      setResearchEquipment(item);
      router.push({
        name: "user-bookings",
        params: { id: getAuth.value.uuid },
      });
    };

    const onLoginRedirectClick = (): void => {
      state.showLoginDialog = false;
      keycloak.login({ redirectUri: window.location.href });
    };

    onMounted(() => {
      getDetailData(id);
      getEquipmentImages(id);
    });

    watch(
      () => props.id,
      (newValue) => {
        getDetailData(newValue);
        getEquipmentImages(id);
      }
    );

    const locationPosition = (): any => {
      return {
        lat: state.item?.location?.latitude || location.lat,
        lng: state.item?.location?.longitude || location.lng,
      };
    };

    function mapResponsibleUserContactView(
      contactUsers: any
    ): ResponsibleUserContactView {
      const user = contactUsers.find((item: any) => item.email != "");
      if (!user) {
        return {
          name: "",
          email: "",
          mobile: "",
        } as ResponsibleUserContactView;
      }
      return {
        name: `${user.firstname} ${user.lastname}`,
        email: user.email,
        mobile: user.phoneNumber,
      } as ResponsibleUserContactView;
    }

    return {
      t,
      state,
      locationPosition,
      onBookEquipmentClick,
      formatDate,
      onLoginRedirectClick,
      defaultLanguageSelected: computed(() => selectedLocale() === Language.sl),
    };
  },
});
